import { useState } from "react"
import { Loader2 } from "lucide-react"
import { LightBtn, PrimaryBtn } from "../../../.."
import If from "../../../../if"
import BBModal from "../../../../modal"
import { DiagnosisResults } from "../../../../pricing-logs/pricing-log-card-details/diagnosis-results"
import { useFetchAiPricingDiagnosisQuery } from "../../../../../../redux/queries"
import QuoteDate from "./date"

interface Props {
  quoteId: string
  timestamp?: number
}

const DiagnosisUI = ({ quoteId, timestamp }: Props) => {
  const [shouldFetchDiagnosis, setShouldFetchDiagnosis] = useState(false)

  const {
    data: diagnosis,
    isLoading: isDiagnosisLoading,
    error: diagnosisError
  } = useFetchAiPricingDiagnosisQuery(quoteId, {
    skip: !shouldFetchDiagnosis || !quoteId
  })

  const onDiagnosePricing = () => {
    setShouldFetchDiagnosis(true)
  }

  const onCloseModal = () => {
    setShouldFetchDiagnosis(false)
  }

  const shouldShowModal =
    shouldFetchDiagnosis && !!diagnosis && !isDiagnosisLoading

  return (
    <div className="py-3">
      <div className="font-extrabold text-lg">
        <QuoteDate timestamp={timestamp} /> -{" "}
        <span className="font-normal text-lg text-red-500">Quote Failed</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-3">
        <div className="py-6 border border-neutral-200 rounded-md h-96 flex flex-col items-center justify-center gap-3 text-center">
          <If
            condition={!shouldFetchDiagnosis}
            then={
              <>
                <p className="text-base-dark text-lg">
                  No rate cards <br /> found for this log
                </p>
                <PrimaryBtn onClick={onDiagnosePricing} disabled={!quoteId}>
                  <span className="text-base block px-6">Run Diagnostic</span>
                </PrimaryBtn>
              </>
            }
          />
          <If
            condition={shouldFetchDiagnosis && isDiagnosisLoading}
            then={
              <>
                <Loader2
                  className="animate-spin h-10 w-10 text-primary-500"
                  aria-hidden="true"
                />
                <p className="text-base-dark text-lg">Analyzing pricing…</p>
              </>
            }
          />
        </div>
      </div>
      <BBModal
        show={shouldShowModal}
        onClose={onCloseModal}
        forceShowCloseButton={true}
        size="xl"
      >
        <DiagnosisResults diagnosis={diagnosis!} />
      </BBModal>
      <If
        condition={shouldFetchDiagnosis && !!diagnosisError}
        then={
          <div className="flex items-center gap-2 mt-3">
            <p className="text-red-500">
              Failed to fetch diagnosis. Please try again.
            </p>
            <PrimaryBtn onClick={onDiagnosePricing}>
              <span className="text-base">Retry</span>
            </PrimaryBtn>
          </div>
        }
      />
    </div>
  )
}

export default DiagnosisUI
